module["exports"] = [
  "NV",
  "BVBA",
  "CVBA",
  "VZW"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/nl_BE/company/suffix.js
// module id = 3330
// module chunks = 1610